import { markRaw } from 'vue';

// A foto e o PDF da página do link (L-19), com as mesmas regras do servidor
// (`PowerAgents::TestLinks::Anexos`): JPEG, PNG, WEBP, GIF e PDF, até 5 MB cada e até 3 por
// mensagem. A página recusa antes de subir, com o motivo; o servidor confere de novo pelo conteúdo.
// Áudio não entra: a nota de voz tem o caminho dela, e chega ao agente como texto.
//
// O Playground do agente (L-23) testa com as mesmas regras, e as lê daqui: o arquivo mora em
// `shared/`, com a conversa das duas telas (L-24), e `test_link/anexos` só o reexporta.
export const TIPOS_ACEITOS = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'application/pdf',
];
export const TAMANHO_MAXIMO = 5 * 1024 * 1024;
export const POR_MENSAGEM = 3;

// Por que o arquivo não entra: `tipo` ou `grande`; null quando entra.
export const recusaDoArquivo = arquivo => {
  if (!TIPOS_ACEITOS.includes(arquivo.type)) return 'tipo';
  if (arquivo.size > TAMANHO_MAXIMO) return 'grande';
  return null;
};

// A miniatura da foto sai do próprio arquivo (`blob:`, que a CSP da página deixa mostrar); o PDF
// aparece pelo nome.
const previa = arquivo =>
  window.URL?.createObjectURL ? window.URL.createObjectURL(arquivo) : '';

export const paraATela = arquivo => ({
  nome: arquivo.name,
  tipo: arquivo.type === 'application/pdf' ? 'pdf' : 'imagem',
  url: arquivo.type === 'application/pdf' ? '' : previa(arquivo),
});

// A miniatura `blob:` prende o arquivo na memória da aba até ser liberada, e quem deixa de
// mostrá-la a libera: a conversa, a do arquivo tirado, a dos enviados e a que ficou quando ela sai
// da tela; o motor e o canal, a das bolhas, ao recomeçar, ao recarregar a conversa e ao encerrar;
// o motor, também quando o resultado traz os anexos do servidor no lugar dela. O endereço que vem
// do servidor não é `blob:` e fica.
export const liberarPrevias = anexos =>
  anexos.forEach(({ url }) => {
    if (url?.startsWith('blob:')) window.URL?.revokeObjectURL?.(url);
  });

// Os arquivos da próxima mensagem depois de mais uma escolha: o que passa entra, até
// POR_MENSAGEM, como `{ arquivo, nome, tipo, url }`; o primeiro que não passa diz por quê, em
// `recusa` (`{ motivo: 'tipo' | 'grande' | 'demais', nome }`, ou null).
export const escolherArquivos = (escolhidos, arquivos) => {
  const lista = [...escolhidos];
  let recusa = null;
  arquivos.forEach(arquivo => {
    const motivo =
      lista.length >= POR_MENSAGEM ? 'demais' : recusaDoArquivo(arquivo);
    if (motivo) {
      recusa ||= { motivo, nome: arquivo.name };
      return;
    }
    lista.push({ arquivo, ...paraATela(arquivo) });
  });
  return { escolhidos: lista, recusa };
};

// Os arquivos que o turno guarda para reenviar: o `File` fica fora da reatividade.
export const guardados = arquivos => arquivos.map(arquivo => markRaw(arquivo));
